<template>
  <div class="app-activation-success">
    <div class="videoIdentWeb" v-if="getSuccessIdent === 'videoIdentWeb'">
      <SuccessContent
        :slotData="{
          SuccessUrl: getSuccessUrl,
          linkEnabled: getClassUrl(),
          msisdn: msisdn
        }"
        type="videoIdent"
      />
      <SuccessContent
        :slotData="{
          SuccessUrl: getSuccessUrl,
          linkEnabled: getClassUrl(),
          msisdn: msisdn
        }"
        type="videoIdentPost"
      />
      <SuccessContent
        :slotData="{
          SuccessUrl: getSuccessUrl,
          linkEnabled: getClassUrl(),
          msisdn: msisdn
        }"
        type="postIdent"
      />
    </div>
    <div class="videoIdentPost" v-if="getSuccessIdent === 'videoIdentPost'">
      <SuccessContent
        :slotData="{
          SuccessUrl: getSuccessUrl,
          linkEnabled: getClassUrl(),
          msisdn: msisdn
        }"
        type="videoIdentPost"
      />
    </div>
    <div class="postIdent" v-if="getSuccessIdent === 'postIdent'">
      <SuccessContent
        :slotData="{
          SuccessUrl: getSuccessUrl,
          linkEnabled: getClassUrl(),
          msisdn: msisdn
        }"
        type="postIdent"
      />
    </div>
  </div>
</template>

<script>
import processSteps from '@/mixins/processSteps'
import { stepName as prevProcessStep } from '../TopUp/EnterTopUpAndPayment.vue'
import { mapGetters, mapMutations } from 'vuex'
import SuccessContent from './SuccessContent.vue'

export const stepName = 'success'

export default {
  name: 'ShowSuccessIdentLinks',
  components: {
    SuccessContent
  },
  mixins: [processSteps(stepName, prevProcessStep, stepName)],
  methods: {
    ...mapMutations('activation', ['goToStep']),
    getClassUrl() {
      if (this.getSuccessUrl !== null) {
        return 'link-set'
      }
      return 'link-unset'
    },
    back() {
      this.goToStep(this.previousStep)
    }
  },
  computed: {
    ...mapGetters('activation/submit', ['getSuccessIdent', 'getSuccessUrl']),
    ...mapGetters('activation/info', ['msisdn'])
  }
}
</script>
